import React, { Component } from 'react';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import CBMediaQuery from '../../shared/CBMediaQuery';
import '../../../App.css';
import { getStyle, SERVICE_FLEET, SERVICE_WORKSHOP } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import CBTextAreaField from '../../shared/form_components/CBTextAreaField';
import {
  createVehicleMaintenance as _createVehicleMaintenance,
  updateVehicleMaintenance as _updateVehicleMaintenance,
} from '../../../actions/vehicleActions';
import {
  getNumberValidator,
  getLengthValidator,
} from '../../../utils/validators';
import CBDatePickerInput from '../../shared/CBDatePickerInput';
import CBModal from '../../shared/CBModal';
import { getMeterLabels } from '../../../utils/equipment';


class AddMaintenanceModal extends Component {
  constructor(props) {
    super(props);
    const { maintenance } = props;

    this.state = {
      formData: {
        km: maintenance ? maintenance.km : '',
        pickup_date: maintenance
          ? moment(maintenance.pickup_date).format('YYYY-MM-DDTHH:mm')
          : moment().format('YYYY-MM-DDTHH:mm'),
        tasks: maintenance && maintenance.tasks && maintenance.tasks.length
          ? maintenance.tasks.map(t => ({
            name: t.name || '', description: t.description || '', amount: t.amount || 1,
          }))
          : [],
        parts: maintenance && maintenance.parts && maintenance.parts.length
          ? maintenance.parts.map(p => ({
            name: p.name || '', type_code: p.type_code || '', manufacturer_code: p.manufacturer_code || '',
            amount: p.amount || 1, unit: p.unit || 'kpl',
          }))
          : [],
        notes: maintenance && maintenance.notes && maintenance.notes.length
          ? maintenance.notes.map(n => ({
            description: n.description || '', description_customer: n.description_customer || '',
          }))
          : [],
      },
      formValid: {
        km: !!maintenance,
      },
    };
  }

  setIsValid = (name, isValid) => {
    const { formValid } = this.state;
    this.setState({ formValid: { ...formValid, [name]: isValid } });
  };

  getIsValid = () => {
    const { formValid } = this.state;
    if (!formValid.km) return false;
    return true;
  };

  updateFormState = changedObject => {
    const { formData } = this.state;
    this.setState({ formData: { ...formData, [changedObject.target]: changedObject.value } });
  };

  handleRowChange = (arrayName, index, field, value) => {
    this.setState(prevState => {
      const updated = [...prevState.formData[arrayName]];
      updated[index] = { ...updated[index], [field]: value };
      return { formData: { ...prevState.formData, [arrayName]: updated } };
    });
  };

  addRow = (arrayName, template) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [arrayName]: [...prevState.formData[arrayName], { ...template }],
      },
    }));
  };

  removeRow = (arrayName, index) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [arrayName]: prevState.formData[arrayName].filter((_, i) => i !== index),
      },
    }));
  };

  submitForm = () => {
    const { formData } = this.state;
    const {
      createVehicleMaintenance,
      updateVehicleMaintenance,
      maintenance,
      closeModal,
      vehicle,
      service,
      selectedWorkshopId,
    } = this.props;

    const payload = {
      vehicle_id: vehicle.id,
      km: formData.km,
      pickup_date: formData.pickup_date,
      tasks: formData.tasks.filter(t => t.name && t.name.trim()),
      parts: formData.parts.filter(p => p.name && p.name.trim()),
      notes: formData.notes.filter(n =>
        (n.description && n.description.trim()) || (n.description_customer && n.description_customer.trim())
      ),
    };

    if (service === SERVICE_FLEET) {
      payload.organization_id = vehicle.organization_id;
    } else if (service === SERVICE_WORKSHOP) {
      payload.workshop_id = selectedWorkshopId;
    }

    if (maintenance) {
      updateVehicleMaintenance(maintenance.id, payload);
    } else {
      createVehicleMaintenance(payload);
    }
    closeModal();
  };

  renderSectionHeader = (screenSize, text, onAdd) => {
    const { t } = this.props;
    return (
      <div style={getStyle(screenSize, styles, 'sectionHeader')}>
        <p className='font-titillium-web-semi-bold' style={getStyle(screenSize, styles, 'sectionTitle')}>
          {text}
        </p>
        {onAdd && (
          <div style={getStyle(screenSize, styles, 'addButton')} className='opacity-on-hover' onClick={onAdd}>
            <img src='/img/icon_plus.svg' alt='add' style={{ height: 16, width: 16, marginRight: 4 }} />
            <span style={{ fontSize: 13, color: '#0095da' }}>{t('addMaintenanceAddRow')}</span>
          </div>
        )}
      </div>
    );
  };

  renderRemoveButton = (onClick) => (
    <div style={styles.default.cardRemoveButton} className='opacity-on-hover' onClick={onClick}>
      <img src='/img/remove.svg' alt='remove' style={{ height: 16, width: 16 }} />
    </div>
  );

  render() {
    const { formData } = this.state;
    const {
      modalIsOpen,
      closeModal,
      afterOpenModal,
      t,
      maintenance,
      vehicle,
    } = this.props;
    // A machine followed by hours keeps its reading in the same `km` column.
    const meter = getMeterLabels(vehicle, t);

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            afterOpenModal={afterOpenModal}
            closeModal={closeModal}
            title={maintenance ? t('updateMaintenanceLabel') : t('addMaintenanceLabel')}
            submitText={t('maintenanceSaveButton')}
            submitForm={this.submitForm}
            isValid={this.getIsValid()}
            vehicleText={vehicle ? vehicle.registration_number : null}
          >
            <div style={getStyle(screenSize, styles, 'bodyContainer')}>

              {/* Date and Km */}
              <div style={getStyle(screenSize, styles, 'topRow')}>
                <div style={getStyle(screenSize, styles, 'topRowField')}>
                  <p className='font-titillium-web-semi-bold' style={getStyle(screenSize, styles, 'inputLabelText')}>
                    {t('addMaintenanceDateLabel')}
                  </p>
                  <div className='datepicker-container-white-bg'>
                    <CBDatePickerInput
                      dateFormat='dd.MM.yyyy HH:mm'
                      displayedDate={moment(formData.pickup_date)}
                      type='datetime'
                      changeDate={(value) => {
                        this.updateFormState({ target: 'pickup_date', value: moment(value).format('YYYY-MM-DDTHH:mm') });
                      }}
                    />
                  </div>
                </div>
                <div style={getStyle(screenSize, styles, 'topRowField')}>
                  <CBInputField
                    name='km'
                    inputStyle={getStyle(screenSize, styles, 'input')}
                    value={formData.km ? parseInt(formData.km) : ''}
                    type='number'
                    placeholder={meter.mode === 'hours' ? meter.readingLabel : t('odometerReading')}
                    onChange={this.updateFormState}
                    validators={[getNumberValidator(), getLengthValidator(1, 8)]}
                    isValidCallback={this.setIsValid}
                    labelText={meter.mode === 'hours' ? meter.readingLabel : t('addMaintenanceKmLabel')}
                    labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                  />
                </div>
              </div>

              {/* Tasks */}
              {this.renderSectionHeader(screenSize, t('addMaintenanceTasksHeading'), () => this.addRow('tasks', { name: '', description: '', amount: 1 }))}
              {formData.tasks.length === 0 && (
                <p style={getStyle(screenSize, styles, 'emptyText')}>{t('addMaintenanceNoTasksYet')}</p>
              )}
              {formData.tasks.map((task, index) => (
                <div key={`task-${index}`} style={getStyle(screenSize, styles, 'card')}>
                  {this.renderRemoveButton(() => this.removeRow('tasks', index))}
                  <div style={getStyle(screenSize, styles, 'cardRow')}>
                    <div style={{ flex: 3 }}>
                      <CBInputField
                        name={`task-name-${index}`}
                        inputStyle={getStyle(screenSize, styles, 'input')}
                        value={task.name}
                        placeholder={t('addMaintenanceTaskName')}
                        onChange={(e) => this.handleRowChange('tasks', index, 'name', e.value)}
                        labelText={t('addMaintenanceTaskName')}
                        labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <CBInputField
                        name={`task-amount-${index}`}
                        inputStyle={getStyle(screenSize, styles, 'input')}
                        value={task.amount}
                        type='number'
                        placeholder='1'
                        onChange={(e) => this.handleRowChange('tasks', index, 'amount', e.value)}
                        labelText={t('addMaintenanceTaskAmount')}
                        labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: 8 }}>
                    <CBInputField
                      name={`task-desc-${index}`}
                      inputStyle={getStyle(screenSize, styles, 'input')}
                      value={task.description}
                      placeholder={t('addMaintenanceTaskDescription')}
                      onChange={(e) => this.handleRowChange('tasks', index, 'description', e.value)}
                      labelText={t('addMaintenanceTaskDescription')}
                      labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                    />
                  </div>
                </div>
              ))}

              {/* Parts */}
              {this.renderSectionHeader(screenSize, t('addMaintenancePartsHeading'), () => this.addRow('parts', { name: '', type_code: '', manufacturer_code: '', amount: 1, unit: 'kpl' }))}
              {formData.parts.length === 0 && (
                <p style={getStyle(screenSize, styles, 'emptyText')}>{t('addMaintenanceNoPartsYet')}</p>
              )}
              {formData.parts.map((part, index) => (
                <div key={`part-${index}`} style={getStyle(screenSize, styles, 'card')}>
                  {this.renderRemoveButton(() => this.removeRow('parts', index))}
                  <div style={getStyle(screenSize, styles, 'cardRow')}>
                    <div style={{ flex: 2 }}>
                      <CBInputField
                        name={`part-name-${index}`}
                        inputStyle={getStyle(screenSize, styles, 'input')}
                        value={part.name}
                        placeholder={t('addMaintenancePartName')}
                        onChange={(e) => this.handleRowChange('parts', index, 'name', e.value)}
                        labelText={t('addMaintenancePartName')}
                        labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <CBInputField
                        name={`part-typecode-${index}`}
                        inputStyle={getStyle(screenSize, styles, 'input')}
                        value={part.type_code}
                        placeholder={t('addMaintenancePartTypeCode')}
                        onChange={(e) => this.handleRowChange('parts', index, 'type_code', e.value)}
                        labelText={t('addMaintenancePartTypeCode')}
                        labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                      />
                    </div>
                  </div>
                  <div style={{ ...getStyle(screenSize, styles, 'cardRow'), marginTop: 8 }}>
                    <div style={{ flex: 2 }}>
                      <CBInputField
                        name={`part-mfgcode-${index}`}
                        inputStyle={getStyle(screenSize, styles, 'input')}
                        value={part.manufacturer_code}
                        placeholder={t('addMaintenancePartManufacturerCode')}
                        onChange={(e) => this.handleRowChange('parts', index, 'manufacturer_code', e.value)}
                        labelText={t('addMaintenancePartManufacturerCode')}
                        labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <CBInputField
                        name={`part-amount-${index}`}
                        inputStyle={getStyle(screenSize, styles, 'input')}
                        value={part.amount}
                        type='number'
                        placeholder='1'
                        onChange={(e) => this.handleRowChange('parts', index, 'amount', e.value)}
                        labelText={t('addMaintenancePartAmount')}
                        labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <CBInputField
                        name={`part-unit-${index}`}
                        inputStyle={getStyle(screenSize, styles, 'input')}
                        value={part.unit}
                        placeholder='kpl'
                        onChange={(e) => this.handleRowChange('parts', index, 'unit', e.value)}
                        labelText={t('addMaintenancePartUnit')}
                        labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                      />
                    </div>
                  </div>
                </div>
              ))}

              {/* Notes */}
              {this.renderSectionHeader(screenSize, t('addMaintenanceNotesHeading'), () => this.addRow('notes', { description: '', description_customer: '' }))}
              {formData.notes.length === 0 && (
                <p style={getStyle(screenSize, styles, 'emptyText')}>{t('addMaintenanceNoNotesYet')}</p>
              )}
              {formData.notes.map((note, index) => (
                <div key={`note-${index}`} style={getStyle(screenSize, styles, 'card')}>
                  {this.renderRemoveButton(() => this.removeRow('notes', index))}
                  <div style={{ marginBottom: 8 }}>
                    <CBTextAreaField
                      name={`note-internal-${index}`}
                      value={note.description}
                      placeholder={t('addMaintenanceNoteInternal')}
                      onChange={(e) => this.handleRowChange('notes', index, 'description', e.value)}
                      labelText={t('addMaintenanceNoteInternal')}
                      labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                    />
                  </div>
                  <div>
                    <CBTextAreaField
                      name={`note-customer-${index}`}
                      value={note.description_customer}
                      placeholder={t('addMaintenanceNoteCustomer')}
                      onChange={(e) => this.handleRowChange('notes', index, 'description_customer', e.value)}
                      labelText={t('addMaintenanceNoteCustomer')}
                      labelTextStyle={getStyle(screenSize, styles, 'fieldLabel')}
                    />
                  </div>
                </div>
              ))}
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 32px',
    },
    topRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: 16,
      marginBottom: 8,
    },
    topRowField: {
      flex: 1,
    },
    inputLabelText: {
      color: 'black',
      textAlign: 'center',
    },
    fieldLabel: {
      color: '#555',
      fontSize: 12,
      textAlign: 'left',
      marginBottom: 2,
    },
    input: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
    },
    sectionHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '2px solid #0095da',
      marginTop: 20,
      marginBottom: 8,
      paddingBottom: 4,
    },
    sectionTitle: {
      fontSize: 15,
      color: '#0095da',
      margin: 0,
    },
    addButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      cursor: 'pointer',
      padding: '2px 8px',
    },
    card: {
      position: 'relative',
      backgroundColor: '#f5f5f5',
      borderRadius: 8,
      padding: '12px 16px',
      marginBottom: 10,
    },
    cardRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: 8,
    },
    cardRemoveButton: {
      position: 'absolute',
      top: 6,
      right: 6,
      cursor: 'pointer',
      padding: 4,
      borderRadius: 4,
      backgroundColor: 'rgba(244, 67, 54, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1,
    },
    emptyText: {
      fontSize: 13,
      color: '#999',
      textAlign: 'center',
      padding: '8px 0',
      margin: 0,
    },
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px',
    },
    topRow: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      marginBottom: 8,
    },
    cardRow: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
    },
  },
};

function mapStateToProps(state) {
  return {
    vehiclePermissionRequest: state.vehiclePermission,
    user: state.authUser.user,
    vehicle: state.vehicle.vehicle,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    service: state.app.service,
  };
}

export default connect(
  mapStateToProps,
  {
    createVehicleMaintenance: _createVehicleMaintenance,
    updateVehicleMaintenance: _updateVehicleMaintenance,
  },
)(translate('VehicleDetailsView')(AddMaintenanceModal));
